(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('PublishMessage', PublishMessage);

    PublishMessage.$inject = ['$resource'];

    function PublishMessage($resource) {
        var resourceUrl = 'api/publishMessage';

        return $resource(resourceUrl, {}, {
            'publishMessage' : {method: 'POST'}
        });
    }
})();
